module.exports = __webpack_public_path__ + "static/media/Helvetica-BoldOblique.1243b706.ttf";